import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../features/auth/services/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthenticationService);

  if (authService.isAuthenticated()) {
    return true;
  } else {
    // Save destination URL for redirection after login
    authService.redirectUrl = state.url;
    return false;
  }
};

